import { render, staticRenderFns } from "./SimpelChart.vue?vue&type=template&id=72b1901c"
import script from "./SimpelChart.vue?vue&type=script&lang=js"
export * from "./SimpelChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports